<template>
    <div class="electronicContractBox">
        <div class="searchBox">
            <div class="search">
                <img class="searchIcon" src="../../../../assets/image/sousuo.png" alt="">
                <input class="searching" type="text" v-model="formData.inputParams" placeholder="请输入合同编号/身份证号/手机号" onKeyUp="value=value.replace(/[\W]/g,'')">
                <div class="clearSearchCongtent"  v-show="isShowClearBtn"  @click="this.handleClear">x</div>
            </div>
            <span class="searchBtn" @click="handleSearch">搜索</span>
        </div>
        <van-popup v-model="isShowPop" class="popTipsBox">
            <p class='popTips'>请输入关键字</p>
        </van-popup>
        <div class="list">
            <van-list
            ref="vanList"
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="getMore"
            class="wrapper"
            >
                <div
                    class="reject"
                    v-for="(item,index) in proList"
                    :key="index"
                   
                >
                    <div class="reject_item">
                        <div class="reject_top" >
                            <div :class="['check', item.select ? 'selected' : '']" @click="clickSelect(item,index)" >
                                 <span class="select-actived"></span>
                                  <!-- <van-checkbox v-model="item.select" checked-color="#07c160" shape="square" @change="clickSelect(item,index)"></van-checkbox> -->
                            </div>
                            <div class="info">
                                <div>合同编号:</div>
                                <div>{{item.cNo}}</div>
                            </div>
                            <div class="info">
                                <div>甲方名称:</div>
                                <div>{{item.cReceiver}}</div>

                            </div>
                            <div class="info">
                                <div>乙方名称:</div>
                                <div>{{item.cName}}</div>
                            </div>
                            <div class="info">
                                <div>生效时间:</div>
                                <div>{{item.cSaveTime}}</div>
                            </div>
                        </div>
                        <div class="reject_bottom"  @click="goDetails(item)">
                            <span>查看详情</span>
                            <img src="../../../../assets/image/ic_lb_jt@3x.png" alt="">
                        </div>
                    </div>
                </div>
            </van-list>
            <!-- </div> -->
            <isNoInfo :isNolist="isNolist"></isNoInfo>
        </div>
        <div class="btns">
            <span :class="{'active':selectItem}" @click="confirm">{{showText}}</span>
        </div>
    </div>
</template>

<script>
    import api from '../../../../service/modules/complaintApis'
    import isNoInfo from '../../../../components/isNoInfo.vue';
    import util from '../../../../utils/common'
    import qs from 'qs';
    export default {
        components: {
            isNoInfo
        },
        data () {
            return {
                isShowClearBtn: false,
                isShowPop: false,
                dataList: [],

                finished: false,
                finishedText: '没有更多',
                loading: true,
                proList: [], // 列表
                pageIndex: '0',
                startTime: '',
                endTime: '',
                ishowRangeTime: false,
                typeList: [],
                scrollY: 0,
                timer: null,
                pickerValue: '',
                isPicker: false,
                currentDate: new Date(),
                pageSize: '10',
                pageNum:1,
                isNolist: false, // 没有内容的状态
                isload: true, // 底部加载中的状态
                message: '加载中...',
                bottomStatus: '',
                cityList: [],
                typeList1: 'timeType',
                cols1: 2,
                typeList2: [],
                cols2: 1,
                typeList3: [],
                cols3: 2,
                isHide: false,
                isShow: false,
                listType: this.$route.query.type, // 列表类型
                areaId: this.$route.query.place,
                warningType: this.$route.query.warningType,
                token:'',
                selectItem:'',
                type:this.$route.query.type,
                item:util.getJsonLocal('item'),
                formData:{
                    curPage:1,
                    pageSize:10,
                    inputParams:''
                }
            }
        },
        computed: {
            // 是否解绑电子合同列表
            isCancle() {
                return (this.$route.query || {}).type === 'cancel';
            },
            // 展示的页面标题以及按钮文案
            showText() {
                return this.isCancle ? '解绑电子合同' : '绑定电子合同'
            },
            // 格式化后查询数据
            formatForm() {
                const formatForm = JSON.parse(JSON.stringify(this.formData));
                if (this.isCancle) {
                    ['mainComplainNumber', 'complainNumber', 'subId'].forEach(prop => {
                        formatForm[prop] = this.item[prop]
                    })
                }
                return formatForm;
            },
        },
        created () {
            this.getToken();
            window.yyn.invokeJSB(
              'setTitle',
              {
                title: this.showText
              },
              cb => {
                console.log('设置title成功：', data);
              }
            );
        },
        methods: {
            clickSelect(item,index){
                this.proList.map(item1=>{
                    this.$set(item1,'select',false)
                })
                console.log(this.proList[index]);
                this.$set(this.proList[index],'select',true)
                this.selectItem=item;
            },
            confirm(){
                if(this.type==="bind"){//绑定电子合同
                    if(!this.selectItem){
                        this.$Toast('请选择你要绑定的合同');
                        return;
                    }
                    this.bindCompany('binding');
                }else{
                    if(!this.selectItem){
                        this.$Toast('请选择你要解除的合同');
                        return;
                    }
                    this.bindCompany('unbind');
                }
                
            },
            bindCompany(type){
                let params={
                    "mainComplainNumber": this.item.mainComplainNumber,
                    "complainNumber":this.item.complainNumber,
                    "subId": this.item.subId,
                    "cNo": this.selectItem.cNo,
                    "cId": this.selectItem.cId,
                    "type": type
                }
                api.worker.operation(params).then(res=>{
                    console.log(res);
                    if(res.ret==0){
                        this.$Toast('绑定成功');
                        this.$router.back();
                    }
                })
            },
            handleClear () {
                this.formData.inputParams = '';
                this.getList();
            },
            handleSearch () {
                this.getList();
            },
            goDetails (item) {
                // debugger;
                console.log(`http://tyn.wiiqq.com/contract/office/#/contractDetail/${item.cId}?token=${this.token}&from=complaint`)
                // return;
                // this.$router.push({
                //     path: '/complaint/electronicDetails',
                //     query:{
                //         id:item.cid,
                //         token:this.token
                //     }
                // })
                window.location.href=`http://tyn.wiiqq.com/contract/office/#/contractDetail/${item.cId}?token=${this.token}&from=complaint`;
                
            },
            getToken(){
                api.worker.getElectronicToken({}).then(res=>{
                    if(res.ret==0){
                        const token=res.data.token;
                        this.token=res.data.token;
                        console.log(process.env.NODE_ENV);
                        this.getList();
                    }
                })
            },
            getList () {
                this.formData.curPage = 1;
                api.worker[this.isCancle ? 'conTractunBindList' : 'conTractlist'](this.formatForm).then(res=>{
                    console.log(res);
                    if(res.ret==0){
                        this.proList=res.data.list;
                        this.proList.map(item=>{
                            this.$set(item,'select',false)
                        })
                    }
                })
                // this.proList = [];
                // this.pageIndex = 1;
                // const params = {
                //     data:{
                //         inputParams: this.inputMsg,
                //         curPage: this.pageIndex,
                //         pageSize: 10
                //     }
                    
                // }
                // api.worker.conTractlist(params).then((res) => {
                //     this.loading = false; // 加载参数
                //     if (res.data.list.length > 0) { // 有数据
                //         this.proList = res.data.list;
                //         if (res.data.list.length === res.data.totalSize) { // 已加载完了
                //             this.finished = true;
                //             this.loading = false;
                //         } else {
                //             this.finished = false;
                //             this.loading = false;
                //         }
                //         this.isNolist = false;
                //     } else {
                //         this.finished = true;
                //         this.loading = false;
                //         this.isNolist = true;
                //         this.finishedText = '';
                //     }
                // })
            },
            getMore () {
                this.formData.curPage++;
                api.worker[this.isCancle ? 'conTractunBindList' : 'conTractlist'](this.formatForm).then(res => {
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = this.proList.concat(res.data.list);
                        if (this.proList.length === res.data.totalSize) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                });
            }
        },
        watch: {
            'formData.inputParams': {
                handler: (val) => {
                    if (val !== '') {
                        this.isShowClearBtn = true
                    } else {
                        this.isShowClearBtn = false
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .electronicContractBox{
        width: 100%;
        min-height: 667px;

        .searchBox::after{
            content: '';
            display: block;
            clear: both;
        }

        .searchBox{
            width: 100%;
            padding: 10px 15px 10px;
            border-bottom: 1px solid #eee;

            .search{
                width: 280px ;
                height: 36px;
                float: left;
                position: relative;

                .searchIcon{
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    top: 10px;
                    left: 10px;
                }

                .searching{
                    width: 220px ;
                    height: 36px;
                    padding: 0 30px;
                    font-size: 14px;
                    margin-right: 5px;
                    background-color: #eee;
                    border-radius: 30px;
                }

                .clearSearchCongtent{
                    width: 16px;
                    height: 16px;
                    font-size: 10px;
                    text-align: center;
                    line-height: 15px;
                    color: #fff;
                    background-color: #666;
                    border-radius: 50%;
                    position: absolute;
                    top: 10px;
                    right: 7px;
                }

            }

            .searchBtn{
                width: 60px;
                font-size: 14px;
                text-align: center;
                line-height: 36px;
                float: left;
            }
        }

        .listBox{

            .noListBox{
                padding-top: 100px;

                .no_list{
                    width: 200px;
                    height: 200px;
                    margin: 0 auto;
                    display: block;
                }
            }
        }

        .popTipsBox{
            width: 150px;
            height: 100px;
            border-radius: 5px;

            .popTips{
                font-size: 18px;
                color: #999;
                text-align: center;
                line-height: 100px;
            }
        }
        .list {
            .wrapper {
                width: 100%;
                .reject {
                    width: 100%;
                    .reject_item {
                        margin: 20px 15px;
                        box-sizing: border-box;
                        background-color: #fff;
                        padding: 16px 16px;
                        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                        position: relative;
                        .check{
                            width:20px;
                            height:20px;
                            position: absolute;
                            box-sizing: border-box;
                            padding: 6px 3px;
                            border: 2px solid #aaa;
                            right:19px;
                            top:26px;
                            .select-actived{
                                display: none;
                                
                                width: 100%;
                                height: 100%;
                                border: 3px solid white;
                                border-top: none;
                                border-right: none;
                                transform: rotate(-45deg);
                                box-sizing: border-box;
                                position: relative;
                                top: -2px;
                            }
                            &.selected{
                                border: none;
                                background-color: @base-color;
                                .select-actived {
                                    display: block;
                                }
                            }
                        }
                        .info {
                            display: flex;
                            margin-top: 12px;
                            div:nth-child(1) {
                                width: 65px;
                                font-size: 14px;
                                color: #777;
                                line-height: 16px;

                            }
                            div:nth-child(2) {
                                font-size: 14px;
                                color: #777;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                line-height: 16px;
                            }
                        }
                        .line {
                            width: 100%;
                            height: 1px;
                            background-color: #eee;
                            margin-top: 25px;
                        }
                        .status {
                            text-align: center;
                            width: 100%;
                            padding: 20px 0;
                            font-size: 18px;
                            color: #666;
                        }
                        .reject_bottom{
                            width:100%;
                            height:40px;
                            display: flex;
                            flex-direction: row;
                            align-content: center;
                            align-items: center;
                            justify-content: space-between;
                            border-top: 1px solid #efefef;
                            margin-top:10px;
                            span{
                                color:#666;
                            }
                            img{
                                width: 15px;
                                height: 14px;
                            }
                        }
                    }
                    .space {
                        width: 100%;
                        height: 4px;
                        background-color: #eee;
                    }
                }
            }
        }
        .btns{
            width:100%;
            position: fixed;
            left:0;
            bottom:0;
            height:48px;
            background-color: #fff;
            display: flex;
            flex-direction:column;
            align-items: center;

            span{
                display: inline-block;
                width:80%;
                height:40px;
                text-align: center;
                line-height: 40px;
                background:rgba(54, 179, 116,.2);
                color:#fff;
                border-radius: 20px;
            }
            .active{
                background-color:@base-color;
            }
        }
    }
</style>
